import React from 'react';
import {Row, Col, Input } from 'antd';
import { useTranslation } from 'react-i18next';

const OrigenFondos = ({origenFondos={}}) => {
    const { t } = useTranslation();
    return (
        <div>
        <Row gutter={[32, 12]}>
            <Col span={12}>
                {t("messages.aml.fundsOriginDescription")}
                <Input readOnly value={origenFondos.origenRecursos &&
                    origenFondos.origenRecursos.map((e) =>{
                    return " "+ (e === 'Otros' ? origenFondos.origenRecursosOtro : e)
                    }
                    )}
                />
            </Col>
            <Col span={12}>
                {t("messages.aml.paymentMethodsDescription")}
                <Input readOnly value={origenFondos.mediosPago &&
                        origenFondos.mediosPago.map((e) =>{
                    return " "+ (e === 'Otros' ? origenFondos.mediosPagoOtro : e)
                    }
                    )}
                />
            </Col>
        </Row>
        </div>
    );
};

export default OrigenFondos;